import state from './state.reducer';
import user from './user.reducer';
import Contatos from './contacts.reducer';
import chat from './chat.reducer';
import {combineReducers} from 'redux';

const reducer = combineReducers({
    state,
    user,
    Contatos,
    chat
});

export default reducer;
